import ABCyaPhaser from '@abcya/abcya_phaser';
import AContainer from '../../library/ExtendedObjects/AContainer.js';
import IntroOrb from './IntroOrb.js';
import IntroWood from './IntroWood.js';
import FontKeys from '../../FontKeys.js';
import ABCyaLib from '@abcya/abcya_lib';

export default class IntroTitle extends AContainer {
  constructor(scene) {
    super(scene);

    this.orangeCount = 0;
    this.blueCount = 0;

    this.cont = this.scene.add.container(0, 0);
    this.add(this.cont);

    this.orb1 = new IntroOrb(this.scene, 1, this);
    this.orb2 = new IntroOrb(this.scene, 2, this);
    this.orb3 = new IntroOrb(this.scene, 3, this);
    this.orb4 = new IntroOrb(this.scene, 4, this);

    this.orbs = [this.orb1, this.orb2, this.orb3, this.orb4];
    this.cont.add(this.orbs);

    this.mainImage = this.scene.addImage(0, 0, 'LogoGear', this.scene.defaultAtlas);
    this.cont.add(this.mainImage);
    this.mainImage.depth = 4;

    let localizationAdj = ABCyaLib.Environment.instance.locale === 'es-US' ? -10 : 0;

    this.titleText1Shadow = ABCyaPhaser.Text.addText(-1, -64 + localizationAdj, 75, 0x352f2c, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('title.journey'), this.cont, true).setResolution(1.5);
    this.titleText1 = ABCyaPhaser.Text.addText(0, -69 + localizationAdj, 75, 0xe2d4bc, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('title.journey'), this.cont, true).setResolution(1.5);
    this.titleText2Shadow = ABCyaPhaser.Text.addText(-1, -3 + localizationAdj, 45, 0x352f2c, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('title.to_the'), this.cont, true).setResolution(1.5);
    this.titleText2 = ABCyaPhaser.Text.addText(0, -8 + localizationAdj, 45, 0xe2d4bc, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('title.to_the'), this.cont, true).setResolution(1.5);
    this.titleText3Shadow = ABCyaPhaser.Text.addText(-1, 55 + localizationAdj, 75, 0x352f2c, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('title.past'), this.cont, true).setResolution(1.5);
    this.titleText3 = ABCyaPhaser.Text.addText(0, 50 + localizationAdj, 75, 0xe2d4bc, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('title.past'), this.cont, true).setResolution(1.5);
    this.titleText1.depth = 4;
    this.titleText2.depth = 4;
    this.titleText3.depth = 4;
    this.titleText1Shadow.depth = 4;
    this.titleText2Shadow.depth = 4;
    this.titleText3Shadow.depth = 4;

    for (let i = 0; i < this.orbs.length; i++) {
      this.orbs[i].depth = i;
      this.scene.addDelay(200, () => { this.orbs[i].tweenInOrb() });
    }

    this.cont.setScale(1.25);
    this.cont.alpha = 0;
    this.cont.setAngle(180);

    this.scene.playSound("intro_gear");
    this.scene.addTween(this.cont, 300, { alpha: 1 }, Phaser.Math.Easing.None);
    this.scene.addTween(this.cont, 750, { angle: 0, scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out);

    this.scene.addDelay(300, () => { this.addWood() });
    this.scene.addDelay(1060, () => { this.setInd() });
  }

  addWood() {
    this.wood = new IntroWood(this.scene);
    this.add(this.wood);

    this.glow = this.create(4, 0, 'LogoOverlay');
    this.glow.alpha = 0;

    this.wood.tweenInWood();
  }

  startPulse() {
    for (let i = 0; i < this.orbs.length; i++) {
      this.orbs[i].flicker();
    }
  }

  endPulse() {
    for (let i = 0; i < this.orbs.length; i++) {
      this.scene.killTween(this.orbs[i].glow);
      this.scene.addTween(this.orbs[i].glow, 300, { alpha: 0 }, Phaser.Math.Easing.None);
    }

    this.scene.killTween(this.glow);
    this.scene.addTween(this.glow, 300, { alpha: 0 }, Phaser.Math.Easing.None);
  }

  updatePulse(ind) {
    if (ind === 1) {
      this.orangeCount++;

      if (this.orangeCount === 2) {
        this.scene.glowOrange.alpha = 1;
        this.scene.tweenPulses("orange");
        this.scene.addTween(this.scene.glowOrange, 5500, { angle: 360, repeat: -1 }, Phaser.Math.Easing.None);
      }
    }
    else if (ind === 2) {
      this.blueCount++;

      if (this.blueCount === 2) {
        this.scene.glowBlue.alpha = 1;
        this.scene.tweenPulses("blue");
        this.scene.addTween(this.scene.glowBlue, 4000, { angle: 360, repeat: -1 }, Phaser.Math.Easing.None);
      }
    }

    if (this.orangeCount === 2 && this.blueCount === 2) {
      for (let i = 0; i < this.orbs.length; i++) {
        this.orbs[i].puslseGlow();
      }

      this.scene.showPlay();

      this.scene.addTween(this.glow, 500, { alpha: 1 }, Phaser.Math.Easing.None,
        () => { this.pulseGlow() });
    }
  }

  pulseGlow() {
    this.scene.addTween(this.glow, 1000, { alpha: .4, yoyo: true, repeat: -1 }, Phaser.Math.Easing.None);
  }

  setInd() {
    for (let i = 0; i < this.orbs.length; i++) {
      this.orbs[i].flicker();
    }

    this.cont.bringToTop(this.orb2);
  }

  cleanUp() {
    for (let i = 0; i < this.orbs.length; i++) {
      this.orbs[i].cleanUp();
      this.orbs[i].destroy();
    }

    this.scene.killTween(this.glow);
    this.glow.destroy();

    this.cont.destroy();
    this.wood.destroy();
  }
}